import LoadingIndicator from '@orn/shared-web/components/LoadingIndicator';
import * as React from 'react';

const DOT_INTERVAL_MS = 1000;
const MAX_DOTS = 3;

/**
 * The bare "working" indicator shown between rounds — tools running, or before
 * the first token — rendered OUTSIDE any speech bubble. A line spinner suffixed
 * with "Thinking" and an ellipsis that builds one period at a time up to three
 * dots (one dot per second), then restarts from none. The spinner sits left of
 * the label so the growing dots never shift it.
 */
export default function ThinkingIndicator(): React.ReactElement {
  const [dotCount, setDotCount] = React.useState(0);
  React.useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((n) => (n + 1) % (MAX_DOTS + 1));
    }, DOT_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="flex items-center gap-2 px-1">
      <LoadingIndicator type="line-spinner" size="xs" />
      <span className="text-tertiary text-xs">Thinking{'.'.repeat(dotCount)}</span>
    </div>
  );
}
